import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import Projects from "./Projects";
import Packages from "./Packages";
import Subcontractors from "./Subcontractors";
import SubcontractorSummary from "./SubcontractorSummary";
import Documents from "./Documents";
import MasterList from "./master-list";
import MasterListItems from "./master-list/Items";
import DocumentExtraction from "./documents_processing/DocumentExtraction";
import DCADocumentProcessor from "./document_creator_assistant/DocumentProcessor";
import DCADocuments from "./document_creator_assistant/Documents";
import QuoteParseEvalComponent from "./quote_parser_eval/QuoteParseEvalComponent";
import DatasetComponent from "./quote_parser_eval/DatasetComponent";
import ProcessEvaluation from "./ProcessEvaluation";
import logo from "./assets/logo.jpg";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [isLoginEnabled] = useState(
        process.env.REACT_APP_LOGIN_ENABLED === "true",
    );
    const Breadcrumbs = () => {
        const location = useLocation();
        const pathnames = location.pathname.split("/").filter((x) => x);

        return (
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    {pathnames.map((value, index) => {
                        const last = index === pathnames.length - 1;
                        const to = `/${pathnames.slice(0, index + 1).join("/")}`;

                        return last ? (
                            <li key={to} className="breadcrumb-item active">
                                {value.charAt(0).toUpperCase() + value.slice(1)}
                            </li>
                        ) : (
                            <li key={to} className="breadcrumb-item">
                                <Link to={to}>
                                    {value.charAt(0).toUpperCase() +
                                        value.slice(1)}
                                </Link>
                            </li>
                        );
                    })}
                </ol>
            </nav>
        );
    };

    useEffect(() => {
        if (!isLoginEnabled) {
            setIsLoggedIn(true);
            return;
        }

        const tokenId = localStorage.getItem("userToken");
        const tokenExpiry = localStorage.getItem("tokenExpiry");
        const currentTime = new Date().getTime();

        if (tokenId && tokenExpiry && currentTime < tokenExpiry) {
            setIsLoggedIn(true);
            setUser({ tokenId });
        } else if (tokenExpiry && currentTime >= tokenExpiry) {
            handleLogout();
            alert("Your session has expired. Please log in again.");
        }
    }, [isLoginEnabled]);

    const handleLoginSuccess = (response) => {
        if (!isLoginEnabled) return;

        const tokenId = response?.credential;
        const expiryTime =
            new Date().getTime() + (response?.expires_in || 3600) * 1000;

        localStorage.setItem("userToken", tokenId);
        localStorage.setItem("tokenExpiry", expiryTime);
        setIsLoggedIn(true);
        setUser({ tokenId });
    };

    const handleLogout = () => {
        localStorage.removeItem("userToken");
        setIsLoggedIn(false);
        setUser(null);
    };

    const handleLoginFailure = (response) => {
        console.log("Login Failed:", response);
    };

    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <BrowserRouter>
                <div className="App">
                    <header className="App-header">
                        <img
                            src={logo}
                            alt="ProQuo Logo"
                            className="App-logo"
                        />
                        <div className="title-container">
                            <h1>ProQuo</h1>
                            <p className="App-subtitle">
                                Processing quotes with AI
                            </p>
                        </div>
                        <div className="breadcrumb-container">
                            <nav className="main-nav">
                                {/* <Link to="/projects">Projects</Link> */}
                                <Link to="/dca">Document Creator</Link>
                                {/* <Link to="/quote_parse_eval">Quote Parser</Link> */}
                                <Link to="/refine-agent">JSON Agent</Link>
                            </nav>
                            <Breadcrumbs />
                        </div>

                        <div className="auth-button-container">
                            {isLoginEnabled &&
                                (!isLoggedIn ? (
                                    <GoogleLogin
                                        onSuccess={handleLoginSuccess}
                                        onError={handleLoginFailure}
                                        useOneTap
                                        className="login-button"
                                    />
                                ) : (
                                    <button
                                        onClick={handleLogout}
                                        className="logout-button"
                                    >
                                        Logout
                                    </button>
                                ))}
                        </div>
                    </header>
                    <ToastContainer />
                    {isLoggedIn ? (
                        <Routes>
                            <Route path="/" element={<Projects />} />
                            <Route path="/projects" element={<Projects />} />
                            <Route
                                path="/projects/:projectId/packages"
                                element={<Packages />}
                            />
                            <Route
                                path="/projects/:projectId"
                                element={<Packages />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId/subcontractors"
                                element={<Subcontractors />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId"
                                element={<Subcontractors />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId/subcontractors/:subcontractorId/documents"
                                element={<Documents />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId/master_list"
                                element={<MasterList />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId/master_list/:groupId/items"
                                element={<MasterListItems />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId/subcontractors/:subcontractorId/documents/:documentId"
                                element={<DocumentExtraction />}
                            />
                            <Route
                                path="/projects/:projectId/packages/:packageId/subcontractors/:subcontractorId/summary"
                                element={<SubcontractorSummary />}
                            />
                            <Route path="/dca" element={<DCADocuments />} />
                            <Route
                                path="/dca/documents/:documentId"
                                element={<DCADocumentProcessor />}
                            />
                            <Route
                                path="/quote_parse_eval"
                                element={<QuoteParseEvalComponent />}
                            />
                            <Route
                                path="/quote_parse_eval/dataset"
                                element={<DatasetComponent />}
                            />
                            <Route
                                path="/refine-agent"
                                element={<ProcessEvaluation />}
                            />
                        </Routes>
                    ) : (
                        <div>Please log in to access the application.</div>
                    )}
                </div>
            </BrowserRouter>
        </GoogleOAuthProvider>
    );
}

export default App;
